const React = require("react");
/*const auth = require("../../Authenticator.js");*/
const server = require("../../Server.js");


function getDivFile(url) {
    return function() {
        server.Get(url).then((res) => {
            res.blob().then((blob) => {
                var url = window.URL.createObjectURL(blob);
                var a = window.document.createElement('a');
                a.href = url;
                a.download = "DivFile.csv";
                a.click();  
            });
        });
    };
}

const DivisionAssignmentsForm = React.createClass({
    render() {
        return (<div>
            Divisional Trainer store assignments file:&nbsp;
            <a href="javascript:void(0)" target="_blank" onClick={getDivFile(this.props.SampleFileURL)}>Click here to download</a>
        </div>);
    }
});

module.exports = DivisionAssignmentsForm;


// WEBPACK FOOTER //
// ./src/components/metadata/DivisionAssignmentsForm.jsx